import { ReactElement } from 'react'
import { Text } from '../..'
import { StyledPriceWithVAT } from './styles'
import { PriceWithVATProps } from './props'

const PriceWithVAT = ({
    price,
    priceSize,
    vatText,
    vatTextSize,
    ...props
}: PriceWithVATProps): ReactElement => (
    <StyledPriceWithVAT {...props}>
        <Text size={priceSize} bold>
            {price}
        </Text>
        {vatText && <Text size={vatTextSize}>{vatText}</Text>}
    </StyledPriceWithVAT>
)

export default PriceWithVAT

export { StyledPriceWithVAT }
